import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router-dom";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import PageHeading from "@/v2/components/ui/heading/Page";
import FindAllTermsAndConditions from "@/v2/api/terms-and-conditions/FindAll";
import { TermsAndCondition } from "@/v2/types";
import {
    TermsAndConditionFilterColumn,
    TermsAndConditionsColumn,
} from "@/v2/components/data-table/columns/TermsAndConditions";
import { Button } from "@/components/ui/button";

export default function TermsAndConditionPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);
    const { skip, limit, search, filter } = queryParams;
    const { refetch, ...query } = useQuery({
        queryKey: ["terms-and-conditions", skip, limit, search, filter],
        queryFn: () =>
            FindAllTermsAndConditions({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });
    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Terms And Condition Templates"
                    description="Manage and monitor all terms and condition templates in your platform"
                />
                <div className="flex gap-4">
                    <Link to={"create"}>
                        <Button>Add Terms And Condition Template</Button>
                    </Link>
                </div>
            </div>
            <Card className="p-2">
                <TableToolbar<TermsAndCondition>
                    column={TermsAndConditionFilterColumn}
                    searchPlaceHolder="Search terms and conditions template"
                />
                <DataTable<TermsAndCondition>
                    data={query.data?.data || []}
                    columns={TermsAndConditionsColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
